import styled from "styled-components";

export const VisualContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const VisualImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const ClientVisualImage = styled(VisualImage)`
  object-fit: cover;
  background-color: #fff;
`;

export const AgencyVisualImage = styled(VisualImage)`
  object-fit: contain;
  background-color: #000;
`;
